var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(_vm.failed)?_c('Expired',{attrs:{"login":"true"}}):_c('div',{staticClass:"sign_up_page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"sign_up_box"},[_c('h1',[_vm._v(_vm._s(_vm.$t("auth.verification.loading")))])])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }